const countries = {
  _notes: 'When adding new keys, please make sure they are also added to the `forms` ',
  list: [
    {
      slug: 'china',
      iso2Code: 'cn',
      name: 'China',
      phoneCode: '+86',
    },
    {
      slug: 'spain',
      iso2Code: 'es',
      name: 'Spain',
      phoneCode: '+34',
    },
    {
      slug: 'germany',
      iso2Code: 'de',
      name: 'Germany',
      phoneCode: '+49',
    },
    {
      slug: 'malaysia',
      iso2Code: 'my',
      name: 'Malaysia',
      phoneCode: '+60',
    },
    {
      slug: 'thailand',
      iso2Code: 'th',
      name: 'Thailand',
      phoneCode: '+66',
    },
    {
      slug: 'hong_kong',
      iso2Code: 'hk',
      name: 'Hong Kong',
      phoneCode: '+852',
    },
    {
      slug: 'afghanistan',
      iso2Code: 'af',
      name: 'Afghanistan',
      phoneCode: '+93',
    },
    {
      slug: 'albania',
      iso2Code: 'al',
      name: 'Albania',
      phoneCode: '+355',
    },
    {
      slug: 'algeria',
      iso2Code: 'dz',
      name: 'Algeria',
      phoneCode: '+213',
    },
    {
      slug: 'american_samoa',
      iso2Code: 'as',
      name: 'American Samoa',
      phoneCode: '+684',
    },
    {
      slug: 'andorra',
      iso2Code: 'ad',
      name: 'Andorra',
      phoneCode: '+376',
    },
    {
      slug: 'angola',
      iso2Code: 'ao',
      name: 'Angola',
      phoneCode: '+244',
    },
    {
      slug: 'antarctica',
      iso2Code: 'aq',
      name: 'Antarctica',
      phoneCode: '+672',
    },
    {
      slug: 'argentina',
      iso2Code: 'ar',
      name: 'Argentina',
      phoneCode: '+54',
    },
    {
      slug: 'armenia',
      iso2Code: 'am',
      name: 'Armenia',
      phoneCode: '+374',
    },
    {
      slug: 'aruba',
      iso2Code: 'aw',
      name: 'Aruba',
      phoneCode: '+297',
    },
    {
      slug: 'ascension_island',
      iso2Code: 'ac',
      name: 'Ascension Island',
      phoneCode: '+247',
    },
    {
      slug: 'austria',
      iso2Code: 'at',
      name: 'Austria',
      phoneCode: '+43',
    },
    {
      slug: 'azerbaijan',
      iso2Code: 'az',
      name: 'Azerbaijan',
      phoneCode: '+994',
    },
    {
      slug: 'bahrain',
      iso2Code: 'bh',
      name: 'Bahrain',
      phoneCode: '+973',
    },
    {
      slug: 'bangladesh',
      iso2Code: 'bd',
      name: 'Bangladesh',
      phoneCode: '+880',
    },
    {
      slug: 'belarus',
      iso2Code: 'by',
      name: 'Belarus',
      phoneCode: '+375',
    },
    {
      slug: 'belgium',
      iso2Code: 'be',
      name: 'Belgium',
      phoneCode: '+32',
    },
    {
      slug: 'belize',
      iso2Code: 'bz',
      name: 'Belize',
      phoneCode: '+501',
    },
    {
      slug: 'benin',
      iso2Code: 'bj',
      name: 'Benin',
      phoneCode: '+229',
    },
    {
      slug: 'bhutan',
      iso2Code: 'bt',
      name: 'Bhutan',
      phoneCode: '+975',
    },
    {
      slug: 'bolivia',
      iso2Code: 'bo',
      name: 'Bolivia',
      phoneCode: '+591',
    },
    {
      slug: 'bosnia_and_herzegovina',
      iso2Code: 'ba',
      name: 'Bosnia and Herzegovina',
      phoneCode: '+387',
    },
    {
      slug: 'botswana',
      iso2Code: 'bw',
      name: 'Botswana',
      phoneCode: '+267',
    },
    {
      slug: 'brazil',
      iso2Code: 'br',
      name: 'Brazil',
      phoneCode: '+55',
    },
    {
      slug: 'british_virgin_islands',
      iso2Code: 'vg',
      name: 'British Virgin Islands',
      phoneCode: '+284',
    },
    {
      slug: 'brunei',
      iso2Code: 'bn',
      name: 'Brunei',
      phoneCode: '+673',
    },
    {
      slug: 'bulgaria',
      iso2Code: 'bg',
      name: 'Bulgaria',
      phoneCode: '+359',
    },
    {
      slug: 'burkina_faso',
      iso2Code: 'bf',
      name: 'Burkina Faso',
      phoneCode: '+226',
    },
    {
      slug: 'burundi',
      iso2Code: 'bi',
      name: 'Burundi',
      phoneCode: '+257',
    },
    {
      slug: 'cambodia',
      iso2Code: 'kh',
      name: 'Cambodia',
      phoneCode: '+855',
    },
    {
      slug: 'cameroon',
      iso2Code: 'cm',
      name: 'Cameroon',
      phoneCode: '+237',
    },
    {
      slug: 'cape_verde',
      iso2Code: 'cv',
      name: 'Cape Verde',
      phoneCode: '+238',
    },
    {
      slug: 'cayman_islands',
      iso2Code: 'ky',
      name: 'Cayman Islands',
      phoneCode: '+345',
    },
    {
      slug: 'central_african_republic',
      iso2Code: 'cf',
      name: 'Central African Republic',
      phoneCode: '+236',
    },
    {
      slug: 'chad',
      iso2Code: 'td',
      name: 'Chad',
      phoneCode: '+235',
    },
    {
      slug: 'chile',
      iso2Code: 'cl',
      name: 'Chile',
      phoneCode: '+56',
    },
    {
      slug: 'clipperton_island',
      iso2Code: 'cp',
      name: 'Clipperton Island',
      phoneCode: '+61',
    },
    {
      slug: 'cocos_keeling_islands',
      iso2Code: 'cc',
      name: 'Cocos [Keeling] Islands',
      phoneCode: '+891',
    },
    {
      slug: 'colombia',
      iso2Code: 'co',
      name: 'Colombia',
      phoneCode: '+57',
    },
    {
      slug: 'congo_kinshasa',
      iso2Code: 'cd',
      name: 'Congo - Kinshasa',
      phoneCode: '+242',
    },
    {
      slug: 'cook_islands',
      iso2Code: 'ck',
      name: 'Cook Islands',
      phoneCode: '+682',
    },
    {
      slug: 'costa_rica',
      iso2Code: 'cr',
      name: 'Costa Rica',
      phoneCode: '+506',
    },
    {
      slug: 'croatia',
      iso2Code: 'hr',
      name: 'Croatia',
      phoneCode: '+385',
    },
    {
      slug: 'cuba',
      iso2Code: 'cu',
      name: 'Cuba',
      phoneCode: '+53',
    },
    {
      slug: 'cyprus',
      iso2Code: 'cy',
      name: 'Cyprus',
      phoneCode: '+357',
    },
    {
      slug: 'czech_republic',
      iso2Code: 'cz',
      name: 'Czech Republic',
      phoneCode: '+420',
    },
    {
      slug: 'denmark',
      iso2Code: 'dk',
      name: 'Denmark',
      phoneCode: '+45',
    },
    {
      slug: 'diego_garcia',
      iso2Code: 'dg',
      name: 'Diego Garcia',
      phoneCode: '+246',
    },
    {
      slug: 'djibouti',
      iso2Code: 'dj',
      name: 'Djibouti',
      phoneCode: '+253',
    },
    {
      slug: 'dominica',
      iso2Code: 'dm',
      name: 'Dominica',
      phoneCode: '+767',
    },
    {
      slug: 'dominican_republic',
      iso2Code: 'do',
      name: 'Dominican Republic',
      phoneCode: '+809',
    },
    {
      slug: 'ecuador',
      iso2Code: 'ec',
      name: 'Ecuador',
      phoneCode: '+593',
    },
    {
      slug: 'egypt',
      iso2Code: 'eg',
      name: 'Egypt',
      phoneCode: '+20',
    },
    {
      slug: 'el_salvador',
      iso2Code: 'sv',
      name: 'El Salvador',
      phoneCode: '+503',
    },
    {
      slug: 'equatorial_guinea',
      iso2Code: 'gq',
      name: 'Equatorial Guinea',
      phoneCode: '+240',
    },
    {
      slug: 'eritrea',
      iso2Code: 'er',
      name: 'Eritrea',
      phoneCode: '+291',
    },
    {
      slug: 'estonia',
      iso2Code: 'ee',
      name: 'Estonia',
      phoneCode: '+372',
    },
    {
      slug: 'ethiopia',
      iso2Code: 'et',
      name: 'Ethiopia',
      phoneCode: '+251',
    },
    {
      slug: 'falkland_islands',
      iso2Code: 'fk',
      name: 'Falkland Islands',
      phoneCode: '+500',
    },
    {
      slug: 'faroe_islands',
      iso2Code: 'fo',
      name: 'Faroe Islands',
      phoneCode: '+298',
    },
    {
      slug: 'fiji',
      iso2Code: 'fj',
      name: 'Fiji',
      phoneCode: '+679',
    },
    {
      slug: 'finland',
      iso2Code: 'fi',
      name: 'Finland',
      phoneCode: '+358',
    },
    {
      slug: 'french_guiana',
      iso2Code: 'gf',
      name: 'French Guiana',
      phoneCode: '+594',
    },
    {
      slug: 'gabon',
      iso2Code: 'ga',
      name: 'Gabon',
      phoneCode: '+241',
    },
    {
      slug: 'gambia',
      iso2Code: 'gm',
      name: 'Gambia',
      phoneCode: '+220',
    },
    {
      slug: 'georgia',
      iso2Code: 'ge',
      name: 'Georgia',
      phoneCode: '+995',
    },
    {
      slug: 'ghana',
      iso2Code: 'gh',
      name: 'Ghana',
      phoneCode: '+233',
    },
    {
      slug: 'gibraltar',
      iso2Code: 'gi',
      name: 'Gibraltar',
      phoneCode: '+350',
    },
    {
      slug: 'greece',
      iso2Code: 'gr',
      name: 'Greece',
      phoneCode: '+30',
    },
    {
      slug: 'greenland',
      iso2Code: 'gl',
      name: 'Greenland',
      phoneCode: '+299',
    },
    {
      slug: 'guadeloupe',
      iso2Code: 'gp',
      name: 'Guadeloupe',
      phoneCode: '+590',
    },
    {
      slug: 'guam',
      iso2Code: 'gu',
      name: 'Guam',
      phoneCode: '+671',
    },
    {
      slug: 'guatemala',
      iso2Code: 'gt',
      name: 'Guatemala',
      phoneCode: '+502',
    },
    {
      slug: 'guinea',
      iso2Code: 'gn',
      name: 'Guinea',
      phoneCode: '+224',
    },
    {
      slug: 'guinea_bissau',
      iso2Code: 'gw',
      name: 'Guinea-Bissau',
      phoneCode: '+245',
    },
    {
      slug: 'guyana',
      iso2Code: 'gy',
      name: 'Guyana',
      phoneCode: '+592',
    },
    {
      slug: 'haiti',
      iso2Code: 'ht',
      name: 'Haiti',
      phoneCode: '+509',
    },
    {
      slug: 'honduras',
      iso2Code: 'hn',
      name: 'Honduras',
      phoneCode: '+504',
    },
    {
      slug: 'hungary',
      iso2Code: 'hu',
      name: 'Hungary',
      phoneCode: '+36',
    },
    {
      slug: 'iceland',
      iso2Code: 'is',
      name: 'Iceland',
      phoneCode: '+354',
    },
    {
      slug: 'india',
      iso2Code: 'in',
      name: 'India',
      phoneCode: '+91',
    },
    {
      slug: 'indonesia',
      iso2Code: 'id',
      name: 'Indonesia',
      phoneCode: '+62',
    },
    {
      slug: 'iran',
      iso2Code: 'ir',
      name: 'Iran',
      phoneCode: '+98',
    },
    {
      slug: 'iraq',
      iso2Code: 'iq',
      name: 'Iraq',
      phoneCode: '+964',
    },
    {
      slug: 'ireland',
      iso2Code: 'ie',
      name: 'Ireland',
      phoneCode: '+353',
    },
    {
      slug: 'israel',
      iso2Code: 'il',
      name: 'Israel',
      phoneCode: '+972',
    },
    {
      slug: 'jamaica',
      iso2Code: 'jm',
      name: 'Jamaica',
      phoneCode: '+876',
    },
    {
      slug: 'japan',
      iso2Code: 'jp',
      name: 'Japan',
      phoneCode: '+81',
    },
    {
      slug: 'jersey',
      iso2Code: 'je',
      name: 'Jersey',
      phoneCode: '+44',
    },
    {
      slug: 'jordan',
      iso2Code: 'jo',
      name: 'Jordan',
      phoneCode: '+962',
    },
    {
      slug: 'kenya',
      iso2Code: 'ke',
      name: 'Kenya',
      phoneCode: '+254',
    },
    {
      slug: 'kiribati',
      iso2Code: 'ki',
      name: 'Kiribati',
      phoneCode: '+686',
    },
    {
      slug: 'kuwait',
      iso2Code: 'kw',
      name: 'Kuwait',
      phoneCode: '+965',
    },
    {
      slug: 'kyrgyzstan',
      iso2Code: 'kg',
      name: 'Kyrgyzstan',
      phoneCode: '+996',
    },
    {
      slug: 'laos',
      iso2Code: 'la',
      name: 'Laos',
      phoneCode: '+856',
    },
    {
      slug: 'latvia',
      iso2Code: 'lv',
      name: 'Latvia',
      phoneCode: '+371',
    },
    {
      slug: 'lebanon',
      iso2Code: 'lb',
      name: 'Lebanon',
      phoneCode: '+961',
    },
    {
      slug: 'lesotho',
      iso2Code: 'ls',
      name: 'Lesotho',
      phoneCode: '+266',
    },
    {
      slug: 'liberia',
      iso2Code: 'lr',
      name: 'Liberia',
      phoneCode: '+231',
    },
    {
      slug: 'libya',
      iso2Code: 'ly',
      name: 'Libya',
      phoneCode: '+218',
    },
    {
      slug: 'liechtenstein',
      iso2Code: 'li',
      name: 'Liechtenstein',
      phoneCode: '+423',
    },
    {
      slug: 'lithuania',
      iso2Code: 'lt',
      name: 'Lithuania',
      phoneCode: '+370',
    },
    {
      slug: 'luxembourg',
      iso2Code: 'lu',
      name: 'Luxembourg',
      phoneCode: '+352',
    },
    {
      slug: 'macau_sar_china',
      iso2Code: 'mo',
      name: 'Macau SAR China',
      phoneCode: '+853',
    },
    {
      slug: 'macedonia',
      iso2Code: 'mk',
      name: 'Macedonia',
      phoneCode: '+389',
    },
    {
      slug: 'madagascar',
      iso2Code: 'mg',
      name: 'Madagascar',
      phoneCode: '+261',
    },
    {
      slug: 'malawi',
      iso2Code: 'mw',
      name: 'Malawi',
      phoneCode: '+265',
    },
    {
      slug: 'maldives',
      iso2Code: 'mv',
      name: 'Maldives',
      phoneCode: '+960',
    },
    {
      slug: 'mali',
      iso2Code: 'ml',
      name: 'Mali',
      phoneCode: '+223',
    },
    {
      slug: 'malta',
      iso2Code: 'mt',
      name: 'Malta',
      phoneCode: '+356',
    },
    {
      slug: 'marshall_islands',
      iso2Code: 'mh',
      name: 'Marshall Islands',
      phoneCode: '+692',
    },
    {
      slug: 'martinique',
      iso2Code: 'mq',
      name: 'Martinique',
      phoneCode: '+596',
    },
    {
      slug: 'mauritania',
      iso2Code: 'mr',
      name: 'Mauritania',
      phoneCode: '+222',
    },
    {
      slug: 'mauritius',
      iso2Code: 'mu',
      name: 'Mauritius',
      phoneCode: '+230',
    },
    {
      slug: 'mayotte',
      iso2Code: 'yt',
      name: 'Mayotte',
      phoneCode: '+269',
    },
    {
      slug: 'mexico',
      iso2Code: 'mx',
      name: 'Mexico',
      phoneCode: '+52',
    },
    {
      slug: 'micronesia',
      iso2Code: 'fm',
      name: 'Micronesia',
      phoneCode: '+691',
    },
    {
      slug: 'moldova',
      iso2Code: 'md',
      name: 'Moldova',
      phoneCode: '+373',
    },
    {
      slug: 'monaco',
      iso2Code: 'mc',
      name: 'Monaco',
      phoneCode: '+33',
    },
    {
      slug: 'mongolia',
      iso2Code: 'mn',
      name: 'Mongolia',
      phoneCode: '+976',
    },
    {
      slug: 'montserrat',
      iso2Code: 'ms',
      name: 'Montserrat',
      phoneCode: '+473',
    },
    {
      slug: 'morocco',
      iso2Code: 'ma',
      name: 'Morocco',
      phoneCode: '+212',
    },
    {
      slug: 'mozambique',
      iso2Code: 'mz',
      name: 'Mozambique',
      phoneCode: '+258',
    },
    {
      slug: 'myanmar_burma',
      iso2Code: 'mm',
      name: 'Myanmar [Burma]',
      phoneCode: '+95',
    },
    {
      slug: 'namibia',
      iso2Code: 'na',
      name: 'Namibia',
      phoneCode: '+264',
    },
    {
      slug: 'nauru',
      iso2Code: 'nr',
      name: 'Nauru',
      phoneCode: '+674',
    },
    {
      slug: 'nepal',
      iso2Code: 'np',
      name: 'Nepal',
      phoneCode: '+977',
    },
    {
      slug: 'netherlands',
      iso2Code: 'nl',
      name: 'Netherlands',
      phoneCode: '+31',
    },
    {
      slug: 'netherlands_antilles',
      iso2Code: 'an',
      name: 'Netherlands Antilles',
      phoneCode: '+599',
    },
    {
      slug: 'new_caledonia',
      iso2Code: 'nc',
      name: 'New Caledonia',
      phoneCode: '+687',
    },
    {
      slug: 'new_zealand',
      iso2Code: 'nz',
      name: 'New Zealand',
      phoneCode: '+64',
    },
    {
      slug: 'nicaragua',
      iso2Code: 'ni',
      name: 'Nicaragua',
      phoneCode: '+505',
    },
    {
      slug: 'niger',
      iso2Code: 'ne',
      name: 'Niger',
      phoneCode: '+227',
    },
    {
      slug: 'nigeria',
      iso2Code: 'ng',
      name: 'Nigeria',
      phoneCode: '+234',
    },
    {
      slug: 'niue',
      iso2Code: 'nu',
      name: 'Niue',
      phoneCode: '+683',
    },
    {
      slug: 'north_korea',
      iso2Code: 'kp',
      name: 'North Korea',
      phoneCode: '+850',
    },
    {
      slug: 'northern_mariana_islands',
      iso2Code: 'mp',
      name: 'Northern Mariana Islands',
      phoneCode: '+1 670',
    },
    {
      slug: 'oman',
      iso2Code: 'om',
      name: 'Oman',
      phoneCode: '+968',
    },
    {
      slug: 'pakistan',
      iso2Code: 'pk',
      name: 'Pakistan',
      phoneCode: '+92',
    },
    {
      slug: 'palau',
      iso2Code: 'pw',
      name: 'Palau',
      phoneCode: '+680',
    },
    {
      slug: 'panama',
      iso2Code: 'pa',
      name: 'Panama',
      phoneCode: '+507',
    },
    {
      slug: 'papua_new_guinea',
      iso2Code: 'pg',
      name: 'Papua New Guinea',
      phoneCode: '+675',
    },
    {
      slug: 'paraguay',
      iso2Code: 'py',
      name: 'Paraguay',
      phoneCode: '+595',
    },
    {
      slug: 'peru',
      iso2Code: 'pe',
      name: 'Peru',
      phoneCode: '+51',
    },
    {
      slug: 'philippines',
      iso2Code: 'ph',
      name: 'Philippines',
      phoneCode: '+63',
    },
    {
      slug: 'poland',
      iso2Code: 'pl',
      name: 'Poland',
      phoneCode: '+48',
    },
    {
      slug: 'portugal',
      iso2Code: 'pt',
      name: 'Portugal',
      phoneCode: '+351',
    },
    {
      slug: 'puerto_rico',
      iso2Code: 'pr',
      name: 'Puerto Rico',
      phoneCode: '+1 787',
    },
    {
      slug: 'qatar',
      iso2Code: 'qa',
      name: 'Qatar',
      phoneCode: '+974',
    },
    {
      slug: 'réunion',
      iso2Code: 're',
      name: 'Réunion',
      phoneCode: '+262',
    },
    {
      slug: 'romania',
      iso2Code: 'ro',
      name: 'Romania',
      phoneCode: '+40',
    },
    {
      slug: 'rwanda',
      iso2Code: 'rw',
      name: 'Rwanda',
      phoneCode: '+250',
    },
    {
      slug: 'saint_kitts_and_nevis',
      iso2Code: 'kn',
      name: 'Saint Kitts and Nevis',
      phoneCode: '+869',
    },
    {
      slug: 'saint_pierre_and_miquelon',
      iso2Code: 'pm',
      name: 'Saint Pierre and Miquelon',
      phoneCode: '+508',
    },
    {
      slug: 'san_marino',
      iso2Code: 'sm',
      name: 'San Marino',
      phoneCode: '+378',
    },
    {
      slug: 'são_tomé_and_príncipe',
      iso2Code: 'st',
      name: 'São Tomé and Príncipe',
      phoneCode: '+239',
    },
    {
      slug: 'saudi_arabia',
      iso2Code: 'sa',
      name: 'Saudi Arabia',
      phoneCode: '+966',
    },
    {
      slug: 'senegal',
      iso2Code: 'sn',
      name: 'Senegal',
      phoneCode: '+221',
    },
    {
      slug: 'seychelles',
      iso2Code: 'sc',
      name: 'Seychelles',
      phoneCode: '+248',
    },
    {
      slug: 'sierra_leone',
      iso2Code: 'sl',
      name: 'Sierra Leone',
      phoneCode: '+232',
    },
    {
      slug: 'singapore',
      iso2Code: 'sg',
      name: 'Singapore',
      phoneCode: '+65',
    },
    {
      slug: 'sint_maarten',
      iso2Code: 'sx',
      name: 'Sint Maarten',
      phoneCode: '+1',
    },
    {
      slug: 'slovakia',
      iso2Code: 'sk',
      name: 'Slovakia',
      phoneCode: '+421',
    },
    {
      slug: 'slovenia',
      iso2Code: 'si',
      name: 'Slovenia',
      phoneCode: '+386',
    },
    {
      slug: 'solomon_islands',
      iso2Code: 'sb',
      name: 'Solomon Islands',
      phoneCode: '+677',
    },
    {
      slug: 'somalia',
      iso2Code: 'so',
      name: 'Somalia',
      phoneCode: '+252',
    },
    {
      slug: 'south_africa',
      iso2Code: 'za',
      name: 'South Africa',
      phoneCode: '+27',
    },
    {
      slug: 'south_georgia_and_the_south_sandwich_islands',
      iso2Code: 'gs',
      name: 'South Georgia and the South Sandwich Islands',
    },
    {
      slug: 'south_korea',
      iso2Code: 'kr',
      name: 'South Korea',
      phoneCode: '+82',
    },
    {
      slug: 'south_sudan',
      iso2Code: 'ss',
      name: 'South Sudan',
      phoneCode: '+211',
    },
    {
      slug: 'sri_lanka',
      iso2Code: 'lk',
      name: 'Sri Lanka',
      phoneCode: '+94',
    },
    {
      slug: 'sudan',
      iso2Code: 'sd',
      name: 'Sudan',
      phoneCode: '+249',
    },
    {
      slug: 'suriname',
      iso2Code: 'sr',
      name: 'Suriname',
      phoneCode: '+597',
    },
    {
      slug: 'svalbard_and_jan_mayen',
      iso2Code: 'sj',
      name: 'Svalbard and Jan Mayen',
      phoneCode: '+47',
    },
    {
      slug: 'swaziland',
      iso2Code: 'sz',
      name: 'Swaziland',
      phoneCode: '+268',
    },
    {
      slug: 'sweden',
      iso2Code: 'se',
      name: 'Sweden',
      phoneCode: '+46',
    },
    {
      slug: 'switzerland',
      iso2Code: 'ch',
      name: 'Switzerland',
      phoneCode: '+41',
    },
    {
      slug: 'syria',
      iso2Code: 'sy',
      name: 'Syria',
      phoneCode: '+963',
    },
    {
      slug: 'taiwan',
      iso2Code: 'tw',
      name: 'Taiwan',
      phoneCode: '+886',
    },
    {
      slug: 'tanzania',
      iso2Code: 'tz',
      name: 'Tanzania',
      phoneCode: '+255',
    },
    {
      slug: 'timor_leste',
      iso2Code: 'tl',
      name: 'Timor-Leste',
      phoneCode: '+670',
    },
    {
      slug: 'togo',
      iso2Code: 'tg',
      name: 'Togo',
      phoneCode: '+228',
    },
    {
      slug: 'tonga',
      iso2Code: 'to',
      name: 'Tonga',
      phoneCode: '+676',
    },
    {
      slug: 'trinidad_and_tobago',
      iso2Code: 'tt',
      name: 'Trinidad and Tobago',
      phoneCode: '+1 868',
    },
    {
      slug: 'tristan_da_cunha',
      iso2Code: 'ta',
      name: 'Tristan da Cunha',
      phoneCode: '+290',
    },
    {
      slug: 'tunisia',
      iso2Code: 'tn',
      name: 'Tunisia',
      phoneCode: '+216',
    },
    {
      slug: 'turkey',
      iso2Code: 'tr',
      name: 'Turkey',
      phoneCode: '+90',
    },
    {
      slug: 'turkmenistan',
      iso2Code: 'tm',
      name: 'Turkmenistan',
      phoneCode: '+993',
    },
    {
      slug: 'turks_and_caicos_islands',
      iso2Code: 'tc',
      name: 'Turks and Caicos Islands',
      phoneCode: '+1 649',
    },
    {
      slug: 'tuvalu',
      iso2Code: 'tv',
      name: 'Tuvalu',
      phoneCode: '+688',
    },
    {
      slug: 'u_s_minor_outlying_islands',
      iso2Code: 'um',
      name: 'U.S. Minor Outlying Islands',
      phoneCode: '+690',
    },
    {
      slug: 'u_s_virgin_islands',
      iso2Code: 'vi',
      name: 'U.S. Virgin Islands',
      phoneCode: '+1 340',
    },
    {
      slug: 'uganda',
      iso2Code: 'ug',
      name: 'Uganda',
      phoneCode: '+256',
    },
    {
      slug: 'ukraine',
      iso2Code: 'ua',
      name: 'Ukraine',
      phoneCode: '+380',
    },
    {
      slug: 'united_arab_emirates',
      iso2Code: 'ae',
      name: 'United Arab Emirates',
      phoneCode: '+971',
    },
    {
      slug: 'uruguay',
      iso2Code: 'uy',
      name: 'Uruguay',
      phoneCode: '+598',
    },
    {
      slug: 'uzbekistan',
      iso2Code: 'uz',
      name: 'Uzbekistan',
      phoneCode: '+7',
    },
    {
      slug: 'vanuatu',
      iso2Code: 'vu',
      name: 'Vanuatu',
      phoneCode: '+678',
    },
    {
      slug: 'vatican_city',
      iso2Code: 'va',
      name: 'Vatican City',
      phoneCode: '+39',
    },
    {
      slug: 'venezuela',
      iso2Code: 've',
      name: 'Venezuela',
      phoneCode: '+58',
    },
    {
      slug: 'vietnam',
      iso2Code: 'vn',
      name: 'Vietnam',
      phoneCode: '+84',
    },
    {
      slug: 'wallis_and_futuna',
      iso2Code: 'wf',
      name: 'Wallis and Futuna',
      phoneCode: '+681',
    },
    {
      slug: 'western_sahara',
      iso2Code: 'eh',
      name: 'Western Sahara',
      phoneCode: '+685',
    },
    {
      slug: 'yemen',
      iso2Code: 'ye',
      name: 'Yemen',
      phoneCode: '+381',
    },
    {
      slug: 'zambia',
      iso2Code: 'zm',
      name: 'Zambia',
      phoneCode: '+260',
    },
    {
      slug: 'zimbabwe',
      iso2Code: 'zw',
      name: 'Zimbabwe',
      phoneCode: '+263',
    },
    {
      slug: 'australia',
      iso2Code: 'au',
      name: 'Australia',
      phoneCode: '+61',
    },
  ],
};

export default countries;
